import { render } from "./CollegeTable.vue?vue&type=template&id=1308fbbb&scoped=true"
import script from "./CollegeTable.vue?vue&type=script&lang=js"
export * from "./CollegeTable.vue?vue&type=script&lang=js"

import "./CollegeTable.vue?vue&type=style&index=0&id=1308fbbb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1308fbbb"]])

export default __exports__